import styled from "styled-components";

import { JobCardSection } from "./JobCardSection";

import { Job } from "@otta/search/schema";
import { media } from "@otta/design";
import { TeamSize } from "@otta/search/components/MeetTheTeam/TeamSize";
import { MissionCard } from "@otta/search/components/MeetTheTeam/MissionCard";
import { OrgChart } from "@otta/search/components/MeetTheTeam/OrgChart";
import { TeamAssets } from "@otta/search/components/MeetTheTeam/TeamAssets";
import { ManagerPrompts } from "@otta/search/components/MeetTheTeam/ManagerPrompts";

type TeamProps = {
  team: NonNullable<Pick<Job.Fragment, "team">["team"]>;
  members: NonNullable<Pick<Job.Fragment, "teamMembers">["teamMembers"]>;
  jobTitle: NonNullable<Pick<Job.Fragment, "title">["title"]>;
};

const Content = styled.div`
  flex-direction: column;
  padding-top: 0.5rem;
  display: flex;
  gap: 1.5rem;
`;

const MobileTeamSize = styled(TeamSize)`
  ${media({ from: "tablet" })`display: none;`}
`;

const DesktopTeamSize = styled(TeamSize)`
  ${media({ from: "tablet" })`display: flex;`}
  display: none;
`;

export function MeetTheTeamSection({
  team,
  members,
  jobTitle,
}: TeamProps): React.ReactElement {
  return (
    <JobCardSection
      title={`Meet the ${team.name}`}
      TopRightComponent={<DesktopTeamSize size={team.size} />}
    >
      <Content data-testid="mtt-content">
        <MobileTeamSize size={team.size} />
        {!!team.mission && <MissionCard>{team.mission}</MissionCard>}
        <TeamAssets assets={team.brandAssetLinks} />
        <OrgChart members={members} jobTitle={jobTitle} teamSize={team.size} />
        <ManagerPrompts team={team} />
      </Content>
    </JobCardSection>
  );
}
